import { render, staticRenderFns } from "./makeNotificationAsRead.vue?vue&type=template&id=efe7ea6c"
import script from "./makeNotificationAsRead.vue?vue&type=script&lang=js"
export * from "./makeNotificationAsRead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/francescobarbieri/Dev/brain/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('efe7ea6c')) {
      api.createRecord('efe7ea6c', component.options)
    } else {
      api.reload('efe7ea6c', component.options)
    }
    module.hot.accept("./makeNotificationAsRead.vue?vue&type=template&id=efe7ea6c", function () {
      api.rerender('efe7ea6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/admin-panel/components/admin/notifications/makeNotificationAsRead.vue"
export default component.exports